// Daka brand: azul y amarillo
const dakaBlue = '#0066B3';
const dakaBlueDark = '#004C8A';
const dakaBlueLight = '#3385C6';
const dakaYellow = '#FFD100';
const dakaYellowDark = '#E6BC00';
const dakaYellowLight = '#FFDA33';

export const light = {
  alternate: {
    main: '#f0f7fc',
    dark: '#e3f0fa',
  },
  cardShadow: 'rgba(0, 102, 179, .12)',
  mode: 'light',
  primary: {
    main: dakaBlue,
    light: dakaBlueLight,
    dark: dakaBlueDark,
    contrastText: '#fff',
  },
  secondary: {
    light: dakaYellowLight,
    main: dakaYellow,
    dark: dakaYellowDark,
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  text: {
    primary: '#2d3748',
    secondary: '#646e73',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: '#fff',
    default: '#fff',
    level2: '#f5f5f5',
    level1: '#fff',
  },
};

export const dark = {
  alternate: {
    main: '#0d2137',
    dark: '#0a1929',
  },
  cardShadow: 'rgba(0, 0, 0, .2)',
  common: {
    black: '#000',
    white: '#fff',
  },
  mode: 'dark',
  primary: {
    main: dakaBlueLight,
    light: '#5ba3e0',
    dark: dakaBlue,
    contrastText: '#fff',
  },
  secondary: {
    light: dakaYellowLight,
    main: dakaYellow,
    dark: dakaYellowDark,
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  text: {
    primary: '#EEEEEF',
    secondary: '#AEB0B4',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#1a2838',
    default: '#1a2838',
    level2: '#243447',
    level1: '#2D3748',
  },
};
